export function propertyPanelImageLinkMacro() {
	// noop intentionally blank. Plugin loaded and init via WRM
}

export function propertyPanelImageLinkMacroWRM() {
	return [
		'wr!com.atlassian.confluence.editor:property-panel-image-link-macro-conf-frontend',
		'wr!com.atlassian.confluence.image.effects.ImageEffectsPlugin:propertiespanel',
	];
}
